module.exports = __webpack_public_path__ + "img/MX_falcon-wings.87d2c45c.svg";